export default "__VITE_ASSET__CP0cQnId__"